// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import ApexCharts from "apexcharts"

// Inline <script> tags in views are non-module and reach these via globals.
window.bootstrap = bootstrap
window.ApexCharts = ApexCharts

// Chart colours come from Tabler's CSS custom properties so theme changes flow
// through. Same accessor Tabler's demo uses as `tabler.getColor`.
window.tablerColor = function (name, opacity) {
  const value = getComputedStyle(document.documentElement)
    .getPropertyValue(`--tblr-${name}`)
    .trim()
  if (!value) return name
  if (opacity === undefined) return value

  const rgb = getComputedStyle(document.documentElement)
    .getPropertyValue(`--tblr-${name}-rgb`)
    .trim()
  return rgb ? `rgba(${rgb}, ${opacity})` : value
}

// Tear charts down before Turbo swaps <body>, or their listeners and
// ResizeObservers leak across visits.
const charts = new Set()

window.registerChart = function (chart) {
  charts.add(chart)
  return chart
}

document.addEventListener("turbo:before-render", () => {
  charts.forEach((chart) => {
    try { chart.destroy() } catch (e) { /* already gone */ }
  })
  charts.clear()
})
